// src/components/Resources/CardMain.tsx
import React from "react";
import Subtitle from "../typography/Subtitle";
import Title from "../typography/Title";
import Description from "../typography/Description";
import { Link } from "react-router-dom";
import { CalendarDotsIcon } from "@phosphor-icons/react/dist/ssr";
import { twMerge } from "tailwind-merge";

const Card = ({
  title,
  link,
  type,
  image,
  description = "",
  datePublished,
  className = "",
}) => {
  const isNews = type === "News";
  const isCaseStudy = type === "Case Study";

  return (
    <Link
      to={link}
      className={twMerge(
        "group/card flex h-full w-full flex-col justify-start gap-4 rounded-bl-md border-b-2 border-transparent p-4 transition-colors duration-500 ease-linear hover:border-app-400",
        className
      )}
    >
      <div
        className={
          isNews
            ? "flex h-40 w-full items-center justify-center rounded-md bg-white p-4"
            : "flex h-auto max-h-[19rem] w-full items-center justify-center"
        }
      >
        <img
          src={image?.src}
          alt=""
          width={image?.width}
          height={image?.height}
          className={`h-auto max-h-full w-auto max-w-full ${
            isNews || isCaseStudy ? "object-contain" : "w-full object-cover"
          }`}
        />
      </div>

      <Subtitle className="text-left text-gray-350">{type}</Subtitle>

      <Title
        size="sm"
        className="line-clamp-3 text-ellipsis text-left transition-colors duration-500 ease-linear [display:-webkit-box] group-hover/card:text-orange-400"
      >
        {title}
      </Title>

      {description && <Description>{description}</Description>}

      {datePublished && (
        <div className="w-full">
          <CalendarDotsIcon
            size={16}
            color="#cfcfcf"
            className="mr-2 inline-block"
          />
          <span className="text-sm text-gray-300">{datePublished}</span>
        </div>
      )}
    </Link>
  );
};

export default Card;
